import { getErrorAsString, isLocalStorageAvailable } from '@notes/webintegrations-common'
import { Constants } from '../Constants'
import { Log } from '../logger/Log'

export function logIfNewShorelineFeedUserFromLocalStorage(): void {
  try {
    if (isLocalStorageAvailable()) {
      if (window.localStorage.getItem(Constants.LOCAL_STORAGE_KEY_FOR_SHORELINE_FEED_USER) !== 'true') {
        window.localStorage.setItem(Constants.LOCAL_STORAGE_KEY_FOR_SHORELINE_FEED_USER, 'true')
        // Logging new shoreline feed users
        Log.logger.logReportData('NewShoreLineFeedUser', false /* isCriticalEvent */)
        const flushEvent = new CustomEvent(Constants.NEW_USER_TO_ON_ECOSYSTEM_TELEMETRY_FLUSH_EVENT, { detail: { MessageId: 'isExistingShorelineFeedUser', Value: false } })
        document.dispatchEvent(flushEvent)
      }
    }
  } catch (error) {
    Log.logger.error(`logIfNewShorelineFeedUserFromLocalStorage threw an error ${getErrorAsString(error)}`)
    return
  }
}
